export const selectLocationHandler = (
  data,
  option,
  locations,
  isLocationSelected,
  isMachineSelected,
  selectedLocations
) => {



  const index = locations.indexOf(option);

  const newValue = !isLocationSelected[index];
  const copyIsLocationSelected = [...isLocationSelected];
  copyIsLocationSelected[index] = newValue;






















  const exitingSpecLocationsValue = Object.values(data).filter(
    (el) => el.isSpecificLocation
  );


  const newIsSpecificLocationSelected = [];
  exitingSpecLocationsValue.forEach((specLocationTitle) => {
    const tempArr = [];

    newIsSpecificLocationSelected.push(tempArr);
    if(data[option].subLocations){
      Object.keys(data[option].subLocations).forEach((el,index) => {
        if (el === Object.keys(specLocationTitle.subLocations)[index]) {
          tempArr.push(newValue);
        } else {
          tempArr.push(false);
        }
      });
    }
  });


  const machineNewArr = isMachineSelected[index]?.map((el) => {
    if (typeof el === "boolean") {
      return newValue;
    } else {
      const machineArr = el?.map((machine) => newValue);
      return machineArr;
    }
  });
  const copyIsMachineSelected = [...isMachineSelected];
  copyIsMachineSelected[index] = machineNewArr;


  const newSelect = newValue
    ? selectedLocations.some((el) => el === option)
      ? [...selectedLocations]
      : [...selectedLocations, option]
    : selectedLocations.filter((el) => el !== option);

  return {
    locationList: copyIsLocationSelected,
    specificLocationList: newIsSpecificLocationSelected,
    machineList: copyIsMachineSelected,
    newSelectedLocations: newSelect,
    select: newValue,
  };
};
